module.exports = __webpack_public_path__ + "img/NAV.ecd04a21.svg";